var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},_vm._l((_vm.group.matches),function(match,m){return _c('match',{key:m,staticClass:"col-12 col-lg-6",attrs:{"match":match,"group":_vm.group}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }